import * as React from 'react';

const Camera = ({ className }) => (
  <svg
    width={24}
    height={20}
    viewBox="0 0 24 20"
    stroke="#FFFFFF"
    strokeWidth={2}
    fill="none"
    fillRule="evenodd"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}>
    <path d="M23,17 C23,18.105 22.105,19 21,19 L3,19 C1.895,19 1,18.105 1,17 L1,6 C1,4.895 1.895,4 3,4 L7,4 L9,1 L15,1 L17,4 L21,4 C22.105,4 23,4.895 23,6 L23,17 Z" />
    <circle cx={12} cy={11} r={4} />
  </svg>
);

export default Camera;



// WEBPACK FOOTER //
// ./src/assets/images/icons/camera.js